
'use client';

import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import { SearchIcon } from 'lucide-react';
import { Container, Row, Col, Card, Button, Table, Label, Input } from 'reactstrap';
import { Tooltip } from "react-tooltip";
import { useNavigate, useParams } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { useLoader } from '../../_helper/LoaderContext';
import MyPagination from '../pagination';
import { useCurrency } from "../../_helper/currencyContext";
import { useLab } from "../../_helper/PharmacyProvider";
import { getTestOrder } from '../TestReport/service/report-test-service';
import { testListBytDoctor } from './service/doctor-service';
import { formatDoctorDisplayDate } from '../../utils/dateTime/dateFormat'

export default function ViewRefrralTest() {
    const { id } = useParams()
    const { t } = useTranslation();
    const [commission, setCommission] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [reportStatus, setReportStatus] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const { getCurrencySymbol } = useCurrency();
    const { currentLab } = useLab();

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search, totalEntries, reportStatus, paymentStatus])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            if (reportStatus) {
                form_data.append("status", reportStatus);
            }
            if (paymentStatus === "paid") {
                form_data.append("isPaid", true);
            }
            else if (paymentStatus === "partial") {
                form_data.append("isPartialPaid", true);
            }
            const res = await testListBytDoctor(id, form_data)
            // console.log(res)
            if (res.data.success == true) {
                setCommission(res.data.data.commissions)
                setTotalEntries(res.data.data.total || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getList();
        }, 500); // waits 0.5s after typing stops

        return () => clearTimeout(delayDebounce);
    }, [search, currentPage, entriesPerPage]);

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <Breadcrumbs mainTitle="Customer Referred By Doctor" parent="Home" subParent="Doctor List" title="Customer Referred By Doctor" />
            <Container fluid={true}>
                <Row >
                    <Col>
                        <Card>
                            <div className="p-3 mt-4">
                                <div className="tw-max-w-full tw-mx-auto">
                                    {/* <div className="row mb-4 align-items-center">
                                        <div className="col-md-6">
                                            <div className="input-group">
                                                <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                                <input type="text" className="form-control icon_form" placeholder="Search By Patient Name..." aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }} value={search} onChange={(e) => setSearch(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <select
                                                className="form-select"
                                                value={paymentStatus}
                                                onChange={(e) => {
                                                    setPaymentStatus(e.target.value);
                                                    setCurrentPage(1); // reset to first page on filter change
                                                }}
                                            >
                                                <option value="">Payment Status</option>
                                                <option value="paid">Paid</option>
                                                <option value="partial">Partial</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <select className="form-select" placeholder="Select Report Status" value={reportStatus}
                                                onChange={(e) => {
                                                    setReportStatus(e.target.value);
                                                    setCurrentPage(1);
                                                }}>
                                                <option value="">Report Status</option>
                                                <option value="Inprogress">Inprogress</option>
                                                <option value="Ordered">Ordered</option>
                                                <option value="Completed">Completed</option>
                                            </select>
                                        </div>
                                    </div> */}
                                    <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                                    >
                                        <Table className="mb-0 table-center table-bordered table-hover" style={{ tableLayout: 'fixed', overflowX: 'auto' }}>
                                            <thead>
                                                <tr>
                                                    <th className="text-center bg-primary tw-text-center" style={{
                                                        width: "50px"   // 👈 add width only to first column
                                                    }}>
                                                        <b>#</b>
                                                    </th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '150px' }}><b>Date</b></th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '160px' }}><b>Transaction Type</b></th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '120px' }}><b>Test Amount</b></th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '160px' }}><b>Commission (%)</b></th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '100px' }}><b>Credit</b></th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '100px' }}><b>Debit</b></th>
                                                    <th className="bg-primary text-white text-left" style={{ width: '150px' }}><b>Balance Amount</b></th>

                                                    {/* <th className="bg-primary text-white text-center" style={{ width: '9%' }}><b>Total</b></th>

                                                    <th className="bg-primary text-white text-center" style={{ width: '10%' }}><b>Payment</b></th>
                                                    <th className="bg-primary text-white text-center" style={{ width: '10%' }}><b>Date</b></th>
                                                    <th className="bg-primary text-white text-center" style={{ width: '10%' }}><b>Report</b></th>
                                                    <th className="bg-primary text-white text-center" style={{ width: '11%' }}><b>Action</b></th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {commission.length > 0 ? (
                                                    commission.map((commission, index) => {
                                                        const serialNumber = getStartingSerialNumber() + index;
                                                        return (
                                                            <tr key={commission._id} className={index % 2 === 0 ? '' : ''}>
                                                                <td className="text-center font-weight-bold">
                                                                    {serialNumber}
                                                                </td>
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <span className='tw-ps-2'>
                                                                        {formatDoctorDisplayDate(commission.createdAt, currentLab) || "-"}
                                                                    </span>
                                                                </td>
                                                                {/* commission Name */}
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <div
                                                                        className="tw-font-medium tw-text-gray-900 " >
                                                                        {commission.actionType == "commission" ?
                                                                            (
                                                                                <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-bold text-capitalize bg-primary">
                                                                                    Commission
                                                                                </span>
                                                                            ) : (
                                                                                <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-bold text-capitalize bg-danger">
                                                                                    Pay Out
                                                                                </span>
                                                                            )}
                                                                    </div>
                                                                </td>
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <div
                                                                        className="tw-font-bold tw-text-gray-900 tw-ps-3" >
                                                                        {commission.totalAmount ? getCurrencySymbol(commission?.baseCurrency) : ''}{commission.totalAmount?.toFixed(2) || "---"}
                                                                    </div>
                                                                </td>
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <span>
                                                                        {commission.commissionPercent || "---"}{commission.commissionPercent && "%"}
                                                                    </span>
                                                                </td>
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <span className='fw-bold text-success'>
                                                                        {commission?.transactionType == "credit" ? (
                                                                            <>
                                                                                {getCurrencySymbol(commission?.baseCurrency)}{commission.commissionAmount?.toFixed(2)}
                                                                            </>
                                                                        ) : (<>---</>)}
                                                                    </span>
                                                                </td>
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <span className='fw-bold text-danger'>
                                                                        {commission?.transactionType == "debit" ? (
                                                                            <>
                                                                                {getCurrencySymbol(commission?.baseCurrency)}{commission.commissionAmount?.toFixed(2)}
                                                                            </>
                                                                        ) : (
                                                                            <>---</>
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    <span className='fw-bold'>
                                                                        {getCurrencySymbol(commission?.baseCurrency)}{commission.balances?.INR?.toFixed(2)}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    )
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan={8}
                                                            className="text-center py-4 text-muted"
                                                        >
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="mt-3">

                                        <MyPagination totalPages={totalPages}
                                            currentPage={currentPage}
                                            onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {/* <Modal show={show} onHide={handleClose}>
                <InvoiceReceipt setUploadModelOpen={handleClose} toggleUploadModel={handleClose} />
            </Modal>
            <Modal show={showResult} onHide={handleCloseResult} centered scrollable>
                <ReportList setUploadModelOpen={handleCloseResult} toggleUploadModel={handleCloseResult} data={data} />
            </Modal> */}

        </>
    );
}